export type TicketType = 'I' | 'M'
export type Gender = 'U' | 'M' | 'F'
export type TicketKind = 'inteira' | 'meia' | 'cortesia'

const TIMEZONE = 'America/Fortaleza'

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

const dateTimeParts = new Intl.DateTimeFormat('pt-BR', {
  timeZone: TIMEZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

export const formatCents = (cents: number): string => currency.format(cents / 100)

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const part = (type: Intl.DateTimeFormatPartTypes): string =>
    dateTimeParts.formatToParts(date).find((p) => p.type === type)?.value ?? ''
  return `${part('day')}/${part('month')}/${part('year')}, ${part('hour')}:${part('minute')}`
}

const dayMonthParts = new Intl.DateTimeFormat('pt-BR', { timeZone: TIMEZONE, day: '2-digit', month: '2-digit' })

export const formatDayMonth = (iso: string | null | undefined): string => {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const part = (type: Intl.DateTimeFormatPartTypes): string =>
    dayMonthParts.formatToParts(date).find((p) => p.type === type)?.value ?? ''
  return `${part('day')}/${part('month')}`
}

export const formatPercent = (value: number): string => `${Math.round(value)}%`

export const formatShare = (value: number): string =>
  `${value.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`

const GENDER_LABELS: Record<Gender, string> = { U: 'Unissex', M: 'Masculino', F: 'Feminino' }

export const genderLabel = (gender: Gender): string => GENDER_LABELS[gender]

export const ticketKind = (ticketType: TicketType, courtesy: boolean): TicketKind => {
  if (courtesy) return 'cortesia'
  return ticketType === 'M' ? 'meia' : 'inteira'
}

const KIND_LABELS: Record<TicketKind, string> = { inteira: 'Inteira', meia: 'Meia', cortesia: 'Cortesia' }

export const ticketKindLabel = (kind: TicketKind): string => KIND_LABELS[kind]

export const LOTE_SEGMENTS = 5

export const filledLoteSegments = (percentage: number): number =>
  Math.min(LOTE_SEGMENTS, Math.max(0, Math.round(percentage / 20)))
